import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { NavBar } from './NavBar.tsx';
import { Footer } from './Footer.tsx';
import { useAuth } from '../../auth/useAuth.ts';
import { recordPageview } from '../../api/pageview.ts';

export function Layout({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  // Public-site traffic only — skip while auth is still resolving (avoids a
  // spurious logged-out beacon on first paint before the session loads) and
  // skip entirely once authenticated, so owners' own portal/admin usage
  // never pollutes the "public site traffic" numbers.
  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    recordPageview(pathname, document.referrer || undefined);
  }, [pathname, isAuthenticated, isLoading]);

  return (
    <div className="flex min-h-screen flex-col">
      <NavBar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
